/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cmdMan1: NonNullable<unknown>, cmdMan2: NonNullable<unknown> }} Manual_Commands_DifferInputs */



/**
* | output |
* | --- |
* | "Manual commands differ: ● cmd-man P1: {cmdMan1} ● cmd-man P2: {cmdMan2}" |
*
* @param {Manual_Commands_DifferInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_commands_differ = /** @type {((inputs: Manual_Commands_DifferInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Commands_DifferInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Manual commands differ:
● cmd-man P1: ${i?.cmdMan1}
● cmd-man P2: ${i?.cmdMan2}`)
	return /** @type {LocalizedString} */ (`Les commandes manuelles diffèrent :
● cmd-man P1 : ${i?.cmdMan1}
● cmd-man P2 : ${i?.cmdMan2}`)
});